import { Col, Modal, Row } from "react-bootstrap";

function ModalRules({ close, sumbit }) {

  const agreeHandler = () => {
      sumbit();
      close();
  }

  const agreeBtnProps = {
    className: "btn-success-style d-flex align-items-center justify-content-center w-100",
    type: "button",
    onClick: agreeHandler,
    children: "قوانین را خواندم و پذیرفتم",
  }

  return (
    <Modal show={true} centered direction="rtl" size="xl">
      <Modal.Body className="d-flex align-item-center justify-content-center text-right">
        <div className="w-100">
          <Row>
            <Col>
              <button {...agreeBtnProps}/>
            </Col>
            <Col>
              <button
                className="btn-cancel-style d-flex align-items-center justify-content-center w-100"
                type="button"
                onClick={close}
              >
                بستن
              </button>
            </Col>
          </Row>
          <p
            style={{
              textAlign: "right",
              direction: "rtl",
              fontSize: "16px",
            }}
          >
            قوانین اجرایی سامانه آواکس :<br />
            <br />
            1-ارسال کننده (کاربر)بایستی در هنگام ثبت سفارش وزن و محتوای بسته را
            بدرستی به دقت و صداقت اعلام نماید چنانچه وزن اعلام شده مغایر با وزن
            واقعی باشد ، سفارش کنسل خواهد شد و مسئولیت تاخیر در ارسال، هزینه
            سفارش مجدد و یا هرگونه خسارت ناشی از این امر به عهده ارسال کننده
            خواهد بود
            <br />
            2- کاربر میبایست آدرس گیرنده را درهنگام ثبت به درستی درج نماید تا
            موجب برگشتی سفارش و یا هزینه های مجدد نگردد
            <br />
            کاربر بایستی آدرس فرستنده اعم از استان، شهر و منطقه را صحیح انتخاب
            نماید و چنانچه این امر به درستی صورت نگیرد مسئولیت ناشی از تاخیر در
            جمع آوری و یا کنسلی سفارش به عهده کاربر خواهد بود
            <br />
            کاربر بایستی از شنبه تا پنجشنبه، جهت تحویل مرسوله به جمع آور تا ساعت
            19 در محل اظهار شده ثبت سفارش (آدرس فرستنده) حضور داشته باشد و در
            صورت عدم حضور، این امر به منزله لغو سفارش است و هیچ مبلغی از بابت
            سفارش لغو شده مسترد نخواهد شد و همچنین هیچ گونه ادعایی در این خصوص
            نخواهد داشت. همچنین در شرایط آب و هوایی بارانی یا برفی و یا مناطق
            گرمسیر (درجه حرارت بالای ۴۵ درجه) و مناطق سرد سیر (درجه حرارت زیر
            صفر درجه) این امکان وجود دارد که فرایند جمع آوری با تاخیر انجام
            پذیرد.
            <br />
            کلیه سفارشات ثبت شده در روزجمعه و ایام تعطیل در اولین روز کاری بعد
            از ثبت سفارش جمع آوری خواهد شد وکاربر در این خصوص هیچ اعتراضی نخواهد
            داشت، <br />
            کاربر میبایست هر گونه شکایت در خصوص خسارت وارده به هر مرسوله ای را
            صرفا ظرف 24ساعت پس از سفارش از و عدم پذیرش آن مرسوله اعلام دارد و در
            غیر این صورت هیچ گونه اعتراضی نخواهد داشت ضمنا تعهد بیمه مرسوله تا
            لحظه تحویل آن به گیرنده اعتبار خواهد داشت.
            <br />
            کاربر بایستی که کالای فاسد شدنی ، ممنوعات پستی و قاچاق، وزن بیش از
            30کیلو، مایعات و ابعاد بیش از 1 متر در مرسوله پستی قرار ندهد و
            مندرجات بند ممنوعات پستی رارعایت نماید <br />
            و همچنین کالای شکستنی ارسال ننماید مگر آنکه کلیه ضوابط بسته بندی را
            رعایت نموده باشد، که در صورت عدم رعایت ضابطه فوق و بروز خسارت، هیچ
            اعتراضی نخواهد داشت و مسئولیت محتوای کلیه کالاهای مندرج در بسته به
            عهدهشخص کاربر می باشد، همچنین شرکت هیچ گونه مسئولیتی در قبال اطلاع
            رسانی بسته بندی مرسوله ندارد و در صورت ارسال مرسوله با هرنوع بسته
            بندی تبعات آن به عهده فرستنده می باشد.
            <br />
            کاربر بایستی سفارش خود را که حاوی کد رهگیری می باشد را پرینت و بر
            روی بسته الصاق نماید وحتما آنرا امضا کند و سپس نسخه دیگر را به امضای
            جمع آور برساند و به عنوان رسید نزد خود نگه دارد. ضمنا کلیه قوانین
            پستی را در خصوص محتوای بسته پستی رعایت نماید و اگر خلاف این امر را
            انجام دهد کلیه مسئولیت های ناشی از خسارت و غیره به عهده کاربر می
            باشد و اگر چنانچه به پرینتر دسترسی نداشته باشد، آدرس فرستنده، گیرنده
            و شماره سفارش را بر روی بسته بندی مرسوله با ماژیک درج بنماید
            <br />
            کاربر نمیتواند کلمه کاربری و رمز عبورخود رادر اختیار فرد دیگری قرار
            دهد که در غیر این صورت کلیه مسئولیت ها و تعهدات مندرج در بند های این
            تعهدنامه به عهده کاربر میباشد <br />
            کاربر قبول میکند کلیه موارد لازم در مورد بسته بندی صحیح و عدل بندی
            را با هزینه خود انجام دهد تا بسته در زمان حمل پاره نشود و چنانچه
            مرسوله به بسته بندی مجدد نیاز داشت هزینه آن را طبق نظرکارشناس
            بپردازد یا مبلغ بسته بندی از حساب کیف پول کاربر اتوماتیک کسر گردد{" "}
            <br />
            خاطر نشان میگردد که سفارش هایی که تا قبل از ساعت 10 همان روز در
            سامانه آواکس ثبت گردد ، جهت جمع آوری ارجاع و تا ساعت 18 از محل ثبت
            شده برای فرستنده جمع آوری میگردد و سفارشاتی که بعد از ساعت 10 ثبت
            گردد حداکثر تا ساعت 12 روز بعد جمع آوری میشود <br />
            کاربر میپذیرد در صورت عدم جمع آوری مرسوله ثبت شده در سامانه ظرف 24
            ساعت تاخیر در جمع آوری را به اطلاع شرکت برسانم در غیر این صورت حق
            هرگونه اعتراض نسبت به جمع آوری کالا را از خود سلب نموده است <br />
            جمع آوری بارها، از درب منزل یا محل کار انجام می شود و و مرسوله
            بایستی باید ، در محل درب ورودی ساختمان تحویل داده شود و در صورت نیاز
            به رویت محتویات مرسوله امکان بازدید آن فراهم گردد.
            <br />
            همچنین چنانچه از درج امضا در بخش امضای مشتری در فاکتوردریافتی از
            سامانه خودداری نماید حق هرگونه اعتراضی را نسبت به دریافت غرامت ناشی
            از خسارت یا فقدان مرسوله را از خود سلب می نماید. <br />
            کاربرنمیتواند از بارکد نامعتبر استفاده نماید در صورتی که از یک بارکد
            نامعتبر(کنسل شده) یا بارکدی که قبلا مرسوله آن ارسال شده استفاده کند.
            شامل جریمه نقدی تا 5 برار هزینه بارکد استفاده شده خواهد شد
            <br />
            مرسوله جمع آوری شده تحت هیچ شراطی عودت داده نخواهد شد مگر اینکه مشکل
            قانونی داشته باشد
            <br />
            <br /> <br />
            کنسلی سفارش
            <br />
            در صورت ثبت سفارش از طریق سامانه آواکس، چنانچه درخواست کنسلی سفارش
            را داشته باشد هیچ مبلغی عودت داده نخواهد شد وچنانچه در زمان تحویل
            مرسولات، بسته ای تحویل داده نشود، به منزله کنسل شدن مرسوله می باشد
            چنانچه مرسوله از سامانه غیرپستی باشد، تا قبل از جمع آوری قابل کنسل
            کردن بوده و چنانچه جمع در زمان ثبت سفارش و استفاده از سرویس پسکرایه
            یا پرداخت در محل مبلغ 1،500،000 ريال داخل کیف پول بلوکه خواهد شد.
            درصورت درخواست کنسل کردن سفارش پس کرایه، چنانچه تعداد سفارش های پس
            کرایه ثبت شده زیر10 سفارش باشد مبلغ عودت و در صورت ثبت سفارش بالای
            10 تا، مبلغ عودت نخواهد شد و از مبلغ بلوکه شده می توان به جای هزینه
            سفارش پیش کرایه استفاده کرد و چنانچه مبلغ بلوکه شده کفاف هزینه را
            ندهد کاربر میبایست هزینه فوق را پرداخت نماید کاربر،چنانچه درخواست
            بازگشت کیف پول را داشته باشد این امر با ارسال تیکت و درخواست بازگشت
            کیف پول امکان پذیر میباشد ۷۲ ساعت پس از ارسال تیکت و اعلام شماره شبا
            مبلغ باقیمانده کیف پول عودت داده خواهد شد
            <br />
            <br />
            تعهدات بیمه ای
            <br />
            کلیه مرسولات تا درب محل گیرنده دارای بیمه می باشد و پس از تحویل به
            گیرنده و دریافت امضای گیرنده، هیچ گونه غرامتی پرداخت نخواهد شد لذا
            گیرنده بایستی از دریافت مرسوله آسیب دیده خودداری نماید شرکت تنها در
            صورتی غرامت خسارت مرسوله را پرداخت می نماید که خود، کالا را بسته
            بندی نموده باشد. همچنین بیمه انتخاب شده متضامن کالاهایی که دارای
            بسته بندی استاندارد نمی باشند، نخواهد بود. مشتریانی که بیش از ۲ بار
            در ۱۰۰ مرسوله درخواست خسارت نمایند هیچگونه خسارتی حتی با رعایت شروط
            فوق پرداخت نخواهد شد در صورت دست دوم بودن کالا، قیمت کالای نو مشابه
            پس از برآورد معادل 50% قیمت کالای نو تا سقف بیمه درخواست شده پرداخت
            میشود در زمان درخواست غرامت برای مرسولات ثبت شده با سرویس ، می
            بایستی مشخصات کارت ملی متقاضی غرامت (تصویر کارت ملی)، آدرس و شماره
            حساب در بخش مشخصات متقاضی غرامت در درسایت درج گردد
            <br />
            <br />
            ممنوعات پستی
            <br />
            ممنوعات پستی به شرح ذیل میباشند: مایعات ، مرسولات شکستنی، تجهیزات
            ماهواره، فیلترشکن ها، دارو ، مشروبات الکی و مواد مخدر، تجهیزات
            نظامی، لوازم جنسی، مواد محترقه، اسکریپت های غیرمجاز، لوازم قمار،
            تجهیزات مخابراتی غیرمجاز، تجهیزات جاسوسی، اقلام مستهجن ، فالگیری و
            رمالی، پول نقد، چک، سفته ، اوراق بهادار و جواهرات، فرش، مدارک
            شناسایی، اسناد و همچنین در ارسال به سایر کشورها هم پس از دریافت
            مرسوله توسط فعال پستی به شما اعلام خواهد شد که مرسوله جزء ممنوعات
            پستی به کشور مقصد مورد نظرشما هست یا خیر زمان بندی جمع آوری سفارش
            هایی که درخواست آنها تا قبل از ساعت 10صبح باشد همان روز و زمان جمع
            آوری سفارشاتی که پس از ساعت10 صبح ثبت شوند، در اولین روز کاری بعد از
            ثبت سفارش خواهد بود .
            <br />
            <br />
            قوانین اجرایی
            <br />
            میپذیرم که وزن و محتوای بسته را بدرستی به دقت و صداقت اعلام
            نماید.اگر چنانچه وزن اعلام شده مغایر با وزن واقعی باشد (که این مورد
            در واحد تجزیه و مبادلات مشخص می گردد)، سفارش کنسل خواهد شد و مسئولیت
            تاخیر در ارسال، هزینه سفارش مجدد و یا هرگونه خسارت ناشی از این امر
            به عهده اینجانب خواهد بود. میپذیرم که آدرس گیرنده را در سیستم به
            درستی اعلام نماید تا موجب برگشتی سفارش و یا هزینه های نگهداری در
            باجه معطله نگردد. میپذیرم هماهنگی لازم را با گیرنده برای اخذ مرسوله
            ای که در باجه معطله می باشد بنماید. میپذیرم آدرس فرستنده اعم از
            استان، شهر و منطقه را صحیح انتخاب نماید و چنانچه این امر به درستی
            صورت نگیرد مسئولیت ناشی از تاخیر در جمع آوری و یا کنسلی سفارش به
            عهده اینجانب خواهد بود. میپذیرم هر گونه شکایت در خصوص خسارت وارده به
            هر مرسوله ای را صرفا ظرف 24ساعت پس از سفارش از و عدم پذیرش آن مرسوله
            اعلام دارم و در غیر این صورت هیچ گونه اعتراضی نخواهد داشت ضمنا تعهد
            بیمه مرسوله تا لحظه تحویل آن به گیرنده اعتبار خواهد داشت. میپذیرم که
            کالای فاسد شدنی ، ممنوعات پستی و قاچاق، وزن بیش از 30کیلو، مایعات و
            ابعاد بیش از 1 متر در مرسوله پستی قرار ندهد و مندرجات بند ممنوعات
            پستی رارعایت نماید . میپذیرم که کالای شکستنی ارسال ننماید مگر آنکه
            کلیه ضوابط بسته بندی را رعایت نموده باشد، که در صورت عدم رعایت ضابطه
            فوق و بروز خسارت، هیچ اعتراضی نخواهد داشت و مسئولیت محتوای کلیه
            کالاهای مندرج در بسته به عهده اینجانب می باشد، همچنین شرکت هیچ گونه
            مسئولیتی در قبال اطلاع رسانی بسته بندی مرسوله ندارد و در صورت ارسال
            مرسوله با هرنوع بسته بندی تبعات آن به عهده فرستنده می باشد. کاربر
            میپزیرد سفارش خود را که حاوی کد رهگیری می باشد را پرینت و بر روی
            بسته الصاق نماید وحتما آنرا امضا کند و سپس نسخه دیگر را به امضای جمع
            آور برساند و به عنوان رسید نزد خود نگهدارد.. ضمنا کلیه قوانین پستی
            را در خصوص محتوای بسته پستی رعایت نماید و اگر خلاف این امر را انجام
            دهد کلیه مسئولیت های ناشی از خسارت و غیره به عهده وی می باشد و اگر
            چنانچه به پرینتر دسترسی نداشته باشد، آدرس فرستنده، گیرنده و شماره
            سفارش را بر روی بسته بندی مرسوله با ماژیک درج بنماید. کاربر میپزیرد
            ازکلمه کاربری و رمز عبورم فرد دیگری استفاده نخواهد کرد که در غیر این
            صورت کلیه مسئولیت ها و تعهدات مندرج در بند های این تعهدنامه به عهده
            اینجانب خواهد بود. میپذیرم کلیه موارد لازم در مورد بسته بندی صحیح و
            عدل بندی را با هزینه خودم انجام دهم تا بسته در زمان حمل پاره نشود و
            چنانچه مرسوله ام به بسته بندی مجدد نیاز داشت هزینه آن را طبق
            نظرکارشناس بپردازم یا مبلغ بسته بندی از حساب کیف پول اینجانب
            اتوماتیک کسر گردد.
            <br />
            متعهد و مطلع هستم که جمع آوری بارها، از درب منزل یا محل کار انجام می
            شود و روند دریافت آن به گونه ای است که بار باید به جمع آور محترم، در
            محل درب ورودی ساختمان تحویل داده شود و در صورت نیاز به رویت محتویات
            مرسوله امکان بازدید آن فراهم گردد. تعهد مینماید چنانچه از درج امضا
            در بخش امضای مشتری در فاکتور خودداری نماید (که بصورت اتوماتیک پس از
            ثبت سفارش دانلود و در اختیارم قرار گرفت) حق هرگونه اعتراضی را نسبت
            به دریافت غرامت ناشی از خسارت یا فقدان مرسوله را از خود سلب می
            نماید. این موارد یکبار دیگر در زمان پرداخت مبلغ هزینه ارسال بصورت
            الکترونیک به تایید اینجانب رسیده است (در زمان پرداخت، تایید نمودم که
            قوانین را خواندم و قبول دارم). . میپذیرم اگر شرکت پستی به هر علتی از
            حمل بسته اینجانب خودداری کرد حق هر گونه اعتراضی را از خود سلب می
            نماید و اجازه شکایت در این خصوص را نخواهد داشت. جهت اطلاع از روند
            پرداخت حق مقر نیز به بخش دستورالعمل مندرج در سایت مراجعه نمایید . در
            صورتی که از یک بارکد نامعتبر(کنسل شده) یا بارکدی که قبلا مرسوله آن
            رهسپاری شده استفاده کنید. شامل جریمه نقدی تا 5 برار هزینه بارکد
            استفاده شده خواهید شد.
            <br /> <br />
            قوانین مالی
            <br />
            <br />
            کنسلی سفارش
            <br />
            می پذیرم در صورت ثبت سفارش از طریق آواکس، چنانچه درخواست کنسلی سفارش
            را داشته باشد هیچ مبلغی عودت داده نخواهد شد می پذیرم چنانچه در زمان
            تحویل مرسولات، بسته ای تحویل داده نشود، به منزله کنسل شدن مرسوله می
            باشد. میپذیرم چنانچه مرسوله از سامانه غیرپستی باشد، تا قبل از جمع
            آوری قابل کنسل کردن بوده و چنانچه برای جمع آوری مراجعه شود یا اینکه
            جمع آوری انجام شود برای کنسلی هیچ وجهی مسترد نخواهد شد. مشتری گرامی
            چنانچه درخواست بازگشت کیف پول را داشته باشید این امر با ارسال تیکت و
            درخواست بازگشت کیف پول امکان پذیر میباشد ۷۲ ساعت پس از ارسال تیکت و
            اعلام شماره شبا مبلغ باقیمانده کیف پول شما عودت داده خواهد شد.
            <br />
            <br />
            ممنوعات پستی
            <br />
            ممنوعات پستی به شرح ذیل میباشند: مایعات ، مرسولات شکستنی، تجهیزات
            ماهواره، فیلترشکن ها، دارو ، مشروبات الکی و مواد مخدر، تجهیزات
            نظامی، لوازم جنسی، مواد محترقه، اسکریپت های غیرمجاز، لوازم قمار،
            تجهیزات مخابراتی غیرمجاز، تجهیزات جاسوسی، اقلام مستهجن ، فالگیری و
            رمالی، پول نقد، چک، سفته ، اوراق بهادار و جواهرات، فرش، مدارک
            شناسایی، اسناد و همچنین در ارسال به سایر کشورها هم پس از دریافت
            مرسوله توسط فعال پستی به شما اعلام خواهد شد که مرسوله جزء ممنوعات
            پستی به کشور مقصد مورد نظرشما هست یا خیر
          </p>

          <Modal.Footer className="d-flex align-item-center justify-content-center">
            <button {...agreeBtnProps} className="btn-success-style w-50" />
          </Modal.Footer>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default ModalRules;
